import React, { useEffect } from 'react'
import blog11 from '../../assets/images/home_page_cloud.jpg'
import blog12 from '../../assets/images/homepage_react.png'
import blog13 from '../../assets/images/homepage_students_success.jpg'
import { Link } from 'react-router-dom'

import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeBlogs = () => {

    useEffect(() => {
        AOS.init();
    }, []);


    return (
        <div className='Home_Blogs_section'>
            <div className='container-fluid'>
                <div className='Home_blogs_sectionheads' data-aos="zoom-in" data-aos-duration="2000">
                    <h1>Newest Stories</h1>
                    <p>Stay up to date with all the exciting happenings at Hamo Tech. Our institute is committed to offering the latest training, workshops, and events to keep you ahead in the tech world. Check out our latest updates and news below</p>
                </div>

                <div className='row'>
                    <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1000">
                        <div className='card'>
                            <div>
                                <img src={blog11} className='img-fluid' />
                            </div>
                            <div className='Home_Blogs_section_content'>
                                <h4>
                                    <a href='#'>Hamo Tech Launches New AWS Training Program</a>
                                </h4>
                                <p className='text-justify'>We are excited to announce the launch of our new AWS Cloud Mastery Program! This advanced course will equip students with the skills needed to manage and optimize cloud infrastructures using AWS. Enrollment is now open for our upcoming cohort starting January 2025.</p>

                                <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                <hr />
                                <div className='Home_Blogs_section_date'>
                                    <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                    {/* <p><span><i class="ri-time-line"></i></span>01 Aug 2024</p> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="1500">
                        <div className='card'>
                            <div>
                                <img src={blog12} className='img-fluid' />
                            </div>
                            <div className='Home_Blogs_section_content'>
                                <h4>
                                    <a href='#'>New React Development Bootcamp Announced</a>
                                </h4>
                                <p className='text-justify'>Our highly anticipated React Development Bootcamp is now open for registration! This one-day intensive workshop will cover everything you need to know about building dynamic applications with React.js. Don’t miss out—secure your spot before it fills up!</p>

                                <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                <hr />
                                <div className='Home_Blogs_section_date'>
                                    <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                    {/* <p><span><i class="ri-time-line"></i></span>01 Aug 2024</p> */}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='col-md-4 mt-4' data-aos="fade-up" data-aos-duration="2000">
                        <div className='card'>
                            <div>
                                <img src={blog13} className='img-fluid' />
                            </div>
                            <div className='Home_Blogs_section_content'>
                                <h4>
                                    <a href='#'>Student Success Stories: Graduates Securing Top Tech Jobs</a>
                                </h4>
                                <p className='text-justify'>The first Hamo Tech Developer Conference was a huge success! Featuring talks from industry experts, live coding sessions, and networking opportunities, the event attracted hundreds of aspiring tech professionals. Stay tuned for next year’s conference dates!</p>

                                <button className='mt-1'>read more<span><i class="ri-check-double-line"></i></span></button>

                                <hr />
                                <div className='Home_Blogs_section_date'>
                                    <p><span><i class="ri-user-2-fill"></i></span>auther</p>
                                    {/* <p><span><i class="ri-time-line"></i></span>01 Aug 2024</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='text-center'>
                    <Link to="/user-blogs"><button>Read More</button></Link>
                </div>
            </div>
        </div>
    )
}

export default HomeBlogs
